import { render } from "./apps.vue?vue&type=template&id=d7b8b1f8"
import script from "./apps.vue?vue&type=script&lang=js"
export * from "./apps.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__